/**
 * This error card isolates insight section failures from the rest of the paid-media dashboard.
 */
import React from 'react';
import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';

interface InsightErrorCardProps {
  readonly message: string;
  readonly minHeight: number;
  readonly testId: string;
}

export const InsightErrorCard: React.FC<InsightErrorCardProps> = ({
  message,
  minHeight,
  testId,
}) => (
  <Column
    alignmentVertical="center"
    backgroundColor="white"
    data-testid={testId}
    minHeight={minHeight}
    spacingInset="400"
    type="outline"
    width="100%"
  >
    <Alert size="small" type="error">
      {message}
    </Alert>
  </Column>
);
